// extracted by mini-css-extract-plugin
export default {"field_wrapper":"style_field_wrapper__ccM3K"};